<template>
    <div class="main">
        <c-panel>
            <explorador></explorador>
        </c-panel>
    </div>
</template>
<script>

import explorador from "./explorador"

export default {
    components:{ explorador }
}
</script>
